import { FormEvent } from 'react';

type Props = {
  onSubmit: (event?: FormEvent) => void;
  children: any;
  className: string;
};

export const Form = (props: Props): JSX.Element => {
  const onSubmit = (event: FormEvent): void => {
    event.preventDefault();
    props.onSubmit(event);
  };

  return (
    <form className={props.className} onSubmit={onSubmit} autoComplete="off">
      {props.children}
    </form>
  );
};
